// src/utils/attribution.js
const COOKIE_NAME = 'mch_attrib'
const TTL_DAYS = 30

function readCookie(name = COOKIE_NAME) {
  const row = document.cookie.split('; ').find((r) => r.startsWith(name + '='))
  if (!row) return null
  try {
    return JSON.parse(decodeURIComponent(row.split('=').slice(1).join('=')))
  } catch {
    return null
  }
}

function readRawCookie(name) {
  const row = document.cookie.split('; ').find((r) => r.startsWith(name + '='))
  return row ? row.split('=').slice(1).join('=') : null
}

function writeCookie(payload) {
  const maxAge = 60 * 60 * 24 * TTL_DAYS
  const value = encodeURIComponent(JSON.stringify(payload))

  // Shared across mchanga.africa + accounts.mchanga.africa
  document.cookie = `${COOKIE_NAME}=${value}; Max-Age=${maxAge}; Path=/; Domain=.mchanga.africa; SameSite=Lax; Secure`
}

/**
 * Captures attribution from URL + Meta _fbp cookie.
 * - Never blanks out existing values when missing on URL
 * - Only writes cookie when something new/changed is detected
 */
export function captureAttributionFromUrl(urlString = window.location.href) {
  const url = new URL(urlString)

  const gclid = url.searchParams.get('gclid') || null
  const fbclid = url.searchParams.get('fbclid') || null

  const utm_source = url.searchParams.get('utm_source') || null
  const utm_medium = url.searchParams.get('utm_medium') || null
  const utm_campaign = url.searchParams.get('utm_campaign') || null
  const utm_term = url.searchParams.get('utm_term') || null
  const utm_content = url.searchParams.get('utm_content') || null

  // Meta browser ID cookie (set by Meta Pixel) - Not always present.
  const fbp = readRawCookie('_fbp') || null

  const existing = readCookie() || {}

  // Only consider as "new" when the incoming value exists and differs
  const changed =
    (gclid && gclid !== existing.gclid) ||
    (fbclid && fbclid !== existing.fbclid) ||
    (fbp && fbp !== existing.fbp) ||
    (utm_source && utm_source !== existing.utm_source) ||
    (utm_medium && utm_medium !== existing.utm_medium) ||
    (utm_campaign && utm_campaign !== existing.utm_campaign) ||
    (utm_term && utm_term !== existing.utm_term) ||
    (utm_content && utm_content !== existing.utm_content)

  if (!changed) return false

  const next = {
    ...existing,

    // IDs: only set when present; otherwise keep existing
    gclid: gclid || existing.gclid || null,
    fbclid: fbclid || existing.fbclid || null,
    fbp: fbp || existing.fbp || null,

    // UTMs: only set when present; otherwise keep existing
    utm_source: utm_source || existing.utm_source || null,
    utm_medium: utm_medium || existing.utm_medium || null,
    utm_campaign: utm_campaign || existing.utm_campaign || null,
    utm_term: utm_term || existing.utm_term || null,
    utm_content: utm_content || existing.utm_content || null,

    captured_at: Date.now(),
    landing_host: window.location.host,
    landing_path: window.location.pathname,
  }

  writeCookie(next)
  return true
}

export function getAttributionCookie() {
  return readCookie()
}
